// extracted by mini-css-extract-plugin
module.exports = {"campaignPromotionModal":"CampaignPromotionCta_campaignPromotionModal__F30um"};